<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-form ref="refForm" :model="formData" class="mt20" label-width="200px">
      <el-form-item label="视频标题：" prop="title" :rules="rules">
        <el-input v-model="formData.title" placeholder="请在这里输入标题(6~30个字" maxlength="30"/>
      </el-form-item>
      <el-form-item label="视频简介：" prop="content" :rules="rules">
        <el-input v-model="formData.content" placeholder="请输入" type="textarea" :rows="6" resize="none"/>
      </el-form-item>
      <el-form-item label="选择视频：" prop="videoType" :rules="rules">
        <el-radio v-model="formData.videoType" label="LOCAL">本地视频</el-radio>
        <el-radio v-model="formData.videoType" label="EXTERNAL">链接视频</el-radio>

        <my-video
            class="mt10"
            v-show="formData.videoType == 'LOCAL'"
            v-model="formData.videoUrl"
            unlimited
        />
        <div v-show="formData.videoType == 'LOCAL'" class="font12 c-999">
          <p>
            上传视频：目前仅支持mp4、rmvb、avi3种视频格式。视频大小、时长理论上无限制，但会影响上传速度和播放效果，请酌情处理
          </p>
          <p>
            站外链接：支持优酷、爱奇艺视频链接和三方服务器存储的视频，可能会存在视频广告、播放失败等因素，具体发布结果以审核和实际效果为准，请知悉
          </p>
        </div>

        <el-input
            v-show="formData.videoType == 'EXTERNAL'"
            v-model="formData.videoLink"
            class="mt10"
            placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="标签：">
        <el-select v-model="formData.label" multiple :multiple-limit="5" placeholder="请选择">
          <el-option
              v-for="item in labelList"
              :key="item.labelId"
              :label="item.labelName"
              :value="item.labelId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="置顶：">
        <el-radio-group v-model="formData.top">
          <el-radio label="Y">是</el-radio>
          <el-radio label="N">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="置顶日期：">
        <el-date-picker
            v-model="formData.topDate"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item class="mt55">
        <el-button size="medium" type="primary" @click="saveBtn">提交审核</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import MyVideo from '@/components/MyVideo.vue'

  import {addVideo, getVideoMineLabel} from '@/api'

  export default {
    name: 'VideoEdit',
    components: {MyVideo},
    data () {
      return {
        rules: this.$store.state.rules.required,
        formData: {
          title: '',
          content: '',
          videoType: 'LOCAL',
          videoLink: '',
          videoUrl: '',
          label: [],
          top: 'Y',
          topDate: [],
        },
        labelList: [],
      }
    },
    created () {
      this.getVideoMineLabelFn()
    },
    methods: {
      getVideoMineLabelFn () {
        getVideoMineLabel().then(res => {
          this.labelList = res.data
        })
      },
      saveBtn () {
        this.$refs['refForm'].validate(valid => {
          if (valid) {
            addVideo({
              title: this.formData.title,
              content: this.formData.content,
              videoUrl: this.formData.videoType == 'EXTERNAL' ? this.formData.videoLink : this.formData.videoUrl,
              source: 1,
              labelIds: this.formData.label,
              stickFlag: this.formData.top,
              videoType: this.formData.videoType,
              stickStartTime: this.formData.topDate && this.formData.topDate.length ? this.formData.topDate[0] : '',
              stickEndTime: this.formData.topDate && this.formData.topDate.length > 1 ? this.formData.topDate[1] : '',
            }).then(res => {
              this.$message.success(res.data)
              this.$router.push('/video/platform')
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>
